import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import PeopleIcon from "@mui/icons-material/People";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
} from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as routes from "../../constants/routes";

const PromotionsMenu = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    {
      label: "Coupons",
      icon: <ConfirmationNumberIcon />,
      route: routes.PROMOTIONS_COUPONS_ROUTE,
    },
    {
      label: "Referrals",
      icon: <PeopleIcon />,
      route: routes.PROMOTIONS_REFERRALS_ROUTE,
    },
    {
      label: "Rewards",
      icon: <CardGiftcardIcon />,
      route: routes.PROMOTIONS_REWARDS_ROUTE,
    },
    {
      label: "Top-Up Bonuses",
      icon: <AccountBalanceWalletIcon />,
      route: routes.PROMOTIONS_TOPUP_BONUSES_ROUTE,
    },
  ];

  return (
    <Paper
      elevation={0}
      sx={{
        width: 200,
        borderRight: "1px solid #e0e0e0",
        height: "100%",
      }}
    >
      <List>
        {menuItems.map((item) => (
          <ListItem
            button={true}
            key={item.route}
            selected={location.pathname === item.route}
            onClick={() => navigate(item.route)}
            sx={{
              "&.Mui-selected": {
                backgroundColor: "whitesmoke",
              },
              "&:hover": {
                backgroundColor: "whitesmoke",
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default PromotionsMenu;
